import{isAllowedProp}from"./expand.js";
import{MISSING_HANDLERS}from"./missing.js";


export const getPathValue=(
target,
pathArray,
{missing:missingOpt,entries})=>
{
const{value,missing}=getDeepValue(target,pathArray);

if(missing&&!missingOpt){
return{matches:false}
}

const entry=entries?{value,path:pathArray,missing}:value;
return{entry,matches:true}
};

const getDeepValue=(value,pathArray)=>{

for(const prop of pathArray){

if(!isPresent(value,prop)||!isAllowedProp(prop)){
return{value:undefined,missing:true}
}


value=value[prop]
}

return{value,missing:false}
};

const isPresent=(value,prop)=>{
if(typeof prop==="string"){
return isPresentProp(value)&&prop in value
}

return isPresentIndex(value)&&prop<value.length
};

const{
array:{isPresent:isPresentIndex},
weakObject:{isPresent:isPresentProp}
}=MISSING_HANDLERS;